import { render } from "./RegistrationInput.vue?vue&type=template&id=4110b06a&scoped=true"
import script from "./RegistrationInput.vue?vue&type=script&lang=js"
export * from "./RegistrationInput.vue?vue&type=script&lang=js"

import "./RegistrationInput.vue?vue&type=style&index=0&id=4110b06a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4110b06a"]])

export default __exports__